/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

// import DoubleImageParallax from './scripts/double-image-parallax';
import ElementInView from './scripts/element-in-view';
import PageStatus from './scripts/page-status';
import MenuToggle from './scripts/menu-toggle';
import ScrollableContent from './scripts/scrollable-content';
import FooterToggle from './scripts/footer-toggle';
import CookiebotToggle from './scripts/cookiebot-toggle';
import ImageLightbox from './scripts/image-lightbox';

const scripts = [
  PageStatus,
  MenuToggle,
  ScrollableContent,
  FooterToggle,
  ElementInView,
  CookiebotToggle,
  ImageLightbox
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
